import { render, staticRenderFns } from "./ScoreSet.vue?vue&type=template&id=2cadf488&"
import script from "./ScoreSet.vue?vue&type=script&lang=js&"
export * from "./ScoreSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports